// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"485":"ecfc1f13ea74f06a29cc","934":"721cdac9c50d09aa4f1f","971":"a443ff3dee527decafcc"}[chunkId] + ".js";
};